import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Container,
  Grid,
  Stack,
  TextField,
  Typography,
  Divider,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import productsImage from "../assets/products.png";
import {
  send_otp,
  forgot_pwd_otp,
  forgot_password,
  reset_password,
} from "../Api service/APIvariables";
import Countdown from "react-countdown";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpValidated, setIsOtpValidated] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [timerKey, setTimerKey] = useState(0);
  const [isTimerEnded, setIsTimerEnded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState(false); // Default Snackbar color
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  // Validate Password
  const validateInput = () => {
    if (password !== "" && confirmPassword !== "") {
      if (password === confirmPassword) {
        setError(false);
      } else {
        setErrorMsg("Passwords do not match");
        setError(true);
      }
    } else {
      setErrorMsg("");
      setError(false);
    }
  };

  // Validate Email
  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    const regex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA0-9]{2,}(?:\.[a-zA-Z]{2,})?$/;
    setIsValid(regex.test(emailValue));
    setEmail(emailValue);
  };

  const sendOtp = () => {
    if (isValid) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("email", email);
      axios
        .post(send_otp, formData)
        .then((response) => {
          setIsLoading(false);
          if (response.data.error) {
            setMessage(response.data.message);
            // setSnackbarSeverity("error");
            setOpen(true);
            setStatus(false);
            setColor(false);
            setTimerKey((prevKey) => prevKey + 1); // Increment timer key to reset countdown
          } else {
            setIsOtpSent(true);
            setMessage(response.data.message);
            setOpen(true);
            setStatus(true);
            setColor(true);
            // setEmail("");
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setMessage("Failed to send OTP. Please try again.");
          setOpen(true);
          setStatus(false);
          setColor(false);
        });
    } else {
      setMessage("Invalid Email ID");
      setOpen(true);
      setStatus(false);
      setColor(false);
    }
  };

  // Handle OTP validation
  const validateOtp = () => {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("otp", otp);
    axios
      .post(forgot_pwd_otp, formData)
      .then((response) => {
        if (response.data.error) {
          setMessage(response.data.message);
          setOpen(true);
          setStatus(false);
          setColor(false);
        } else {
          setIsOtpValidated(true);
          setMessage("OTP validated successfully.");
          setOpen(true);
          setStatus(true);
          setColor(true);
          setOtp("");
        }
      })
      .catch((err) => {
        setMessage("Failed to validate OTP. Please try again.");
        setOpen(true);
        setStatus(false);
        setColor(false);
      });
  };

  // Timer renderer for Countdown component
  const countdownRenderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setIsTimerEnded(true); // Set timer ended state when countdown completes
      return null; // Hide the timer when it's done
    }
    return (
      <Typography>
        {minutes < 10 ? `0${minutes}` : minutes}:
        {seconds < 10 ? `0${seconds}` : seconds}
      </Typography>
    );
  };

  // Resend Otp
  const resendOtp = () => {
    const formData = new FormData();
    formData.append("email", email);
    axios
      .post(send_otp, formData)
      .then((response) => {
        if (response.data.error) {
          setTimerKey((prevKey) => prevKey + 1); // Reset the timer
          setIsTimerEnded(false); // Reset timer state
          setMessage(response.data.message);
          setOpen(true);
          setStatus(false);
          setColor(false);
        } else {
          setMessage(response.data.message);
          setOpen(true);
          setStatus(true);
          setColor(true);
        }
      })
      .catch((err) => {
        setMessage("Failed to resend OTP. Please try again.");
        setOpen(true);
        setStatus(false);
        setColor(false);
      });
  };

  // Handle password update
  const submit = () => {
    if (isValid) {
      if (password === confirmPassword) {
        const formData = new FormData();
        formData.append("new_password", password);
        formData.append("email", email);
        axios
          .post(reset_password, formData)
          .then((res) => {
            console.log("Response:", res);
            if (res.data.error) {
              setMessage(res.data.message);
              setOpen(true);
              setStatus(false);
              setColor(false);
            } else {
              setMessage(res.data.message);
              setOpen(true);
              setStatus(true);
              setColor(true);
              setPassword("");
              setConfirmPassword("");
              navigate("/login");
            }
          })
          .catch((err) => {
            setMessage("Oops, something went wrong.");
            setOpen(true);
            setStatus(false);
            setColor(false);
          });
      } else {
        setMessage("Passwords do not match");
        setOpen(true);
        setStatus(false);
        setColor(false);
      }
    } else {
      setMessage("Invalid Email ID");
      setOpen(true);
      setStatus(false);
      setColor(false);
    }
  };

  // const countdownRenderer = ({ minutes, seconds }) => {
  //   return (
  //     <Typography>
  //       {minutes < 10 ? `0${minutes}` : minutes}:
  //       {seconds < 10 ? `0${seconds}` : seconds}
  //     </Typography>
  //   );
  // };

  // const MaskEmail = () => {

  const maskEmail = () => {
    // const [email, setEmail] = useState("example@gmail.com");

    const [username, domain] = email.split("@");
    const maskedUsername = username.slice(0, 2) + "*" + username.slice(-2);
    return `${maskedUsername}@${domain}`;
  };

  // Close the snackbar
  const handleSnackbarClose = () => {
    setOpen(false);
  };

  return (
    <Box
      className="forgot-password"
      sx={{ backgroundColor: "#eaf4fc", height: "100vh" }}
    >
      <Divider
      // sx={{ borderColor: "silver" }}
      />
      <Container>
        <Box py={5}>
          <Grid
            container
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop="42px"
          >
            {/* Left Column: Image */}
            <Grid
              item
              xs={0}
              md={6}
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  p: 2,
                }}
              >
                <img
                  src={productsImage}
                  alt="Products"
                  style={{
                    maxWidth: "80%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Grid>

            {/* Right Column: Forgot Password Form */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  // backgroundColor: "white",
                  justifyContent: "center",
                  alignItems: "center",
                  height: { xs: "auto", sm: "80vh", md: "auto" },
                  px: { xs: 2, sm: 4, md: 5 },
                  padding: "20px",
                  width: { xs: "90%", sm: "80%", md: "70%" },
                  mx: "auto",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "white",
                    border: "1px solid #eaf4fc",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                    p: 4,
                    width: "100%",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#eaf4fc",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#eaf4fc",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#eaf4fc",
                    },
                  }}
                >
                  <Stack spacing={2} width="100%">
                    {/* Forgot Password Heading */}
                    <Typography
                      variant="h5"
                      fontWeight={600}
                      color="#52459f"
                      gutterBottom
                      sx={{ textAlign: "center" }}
                    >
                      Forgot Password
                    </Typography>
                    <Typography
                      color="#707070"
                      // fontWeight={300}
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: 12, sm: 13, md: 15 },
                      }}
                    >
                      Enter your email address to receive an OTP and reset your
                      password.
                    </Typography>

                    {!isOtpSent ? (
                      <>
                        <TextField
                          sx={{
                            // height: { xs: 40, sm: 45, md: 50 },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Default border color
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Same border color on hover
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Focused border color
                            },
                            fontSize: { xs: 12, sm: 13, md: 14 },
                          }}
                          id="email"
                          name="email"
                          type="email"
                          autoComplete="email"
                          fullWidth
                          onChange={handleEmailChange}
                          size="small"
                          required
                          value={email}
                          label="Your Email ID here" // Added label
                        />
                        <Button
                          variant="contained"
                          disabled={isLoading}
                          onClick={sendOtp}
                          sx={{
                            height: 40,
                            boxShadow: "none",
                            bgcolor: "#52459f",
                          }}
                        >
                          {isLoading ? "Sending..." : "Send OTP"}
                        </Button>
                      </>
                    ) : !isOtpValidated ? (
                      <>
                        {isOtpSent && (
                          <Typography
                            // fontWeight={500}
                            color="#707070"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              alignContent: "center",
                              fontSize: { xs: 12, sm: 13, md: 15 },
                            }}
                          >
                            OTP has been sent to your {maskEmail()} account.
                          </Typography>
                        )}

                        <TextField
                          sx={{
                            width: "100%",
                            marginBottom: 2,
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                            fontSize: { xs: 12, sm: 13, md: 15 },
                          }}
                          size="small"
                          id="otp"
                          variant="outlined"
                          name="otp"
                          type="text"
                          onChange={(e) => setOtp(e.target.value)}
                          value={otp}
                          label="Enter OTP" // Added label
                        />

                        {isOtpSent && !isOtpValidated && (
                          <Grid
                            container
                            spacing={2}
                            sx={{ justifyContent: "flex-end", marginTop: 1 }}
                          >
                            <Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                // fontSize: "20px",
                              }}
                            >
                              {!isTimerEnded && (
                                <Countdown
                                  key={timerKey}
                                  date={Date.now() + 120000}
                                  renderer={countdownRenderer}
                                  onComplete={() => setIsTimerEnded(true)}
                                />
                              )}
                            </Grid>
                            <Grid
                              item
                              xs={8}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                right: 0,
                                ml: 2,
                              }}
                            >
                              {isTimerEnded && (
                                <Button
                                  variant="text"
                                  onClick={resendOtp}
                                  sx={{
                                    height: 40,
                                    boxShadow: "none",
                                    color: "#52459f",
                                    // marginTop: 2,
                                    textTransform: "none",
                                    // ml: 2,
                                  }}
                                >
                                  Resend OTP
                                </Button>
                              )}
                            </Grid>
                          </Grid>
                        )}
                        <Button
                          variant="contained"
                          onClick={validateOtp}
                          sx={{
                            height: 40,
                            boxShadow: "none",
                            bgcolor: "#52459f", // Updated button color
                          }}
                        >
                          Validate OTP
                        </Button>
                      </>
                    ) : (
                      <>
                        {/* <Typography
                          fontWeight={500}
                          color="#707070"
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                          }}
                        >
                          New Password
                        </Typography> */}
                        <Typography
                          fontWeight={500}
                          color="#707070"
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          OTP has been sent to your {maskEmail()} account.
                        </Typography>
                        <TextField
                          sx={{
                            width: "100%",
                            marginBottom: 5,
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Default border color
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Same border color on hover
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Focused border color
                            },
                          }}
                          size="small"
                          id="password"
                          variant="outlined"
                          name="password"
                          type="password"
                          onChange={(e) => setPassword(e.target.value)}
                          onBlur={validateInput}
                          value={password}
                          label="New Password*" // Added label
                        />
                        {/* <Typography fontWeight={500} color="#707070">
                          Confirm New Password
                        </Typography> */}
                        <TextField
                          sx={{
                            width: "100%",
                            marginBottom: 5,
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Default border color
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Same border color on hover
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc", // Focused border color
                            },
                          }}
                          size="small"
                          id="confirmPassword"
                          variant="outlined"
                          name="confirmPassword"
                          type="password"
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          helperText={errorMsg}
                          error={error}
                          onBlur={validateInput}
                          value={confirmPassword}
                          label="Confirm New Password*" // Added label
                        />
                        <Button
                          variant="contained"
                          onClick={submit}
                          sx={{
                            height: { xs: 40, sm: 45, md: 50 },
                            boxShadow: "none",
                            bgcolor: "#52459f", // Updated button color
                          }}
                        >
                          Update Password
                        </Button>
                      </>
                    )}
                  </Stack>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      {/* Snackbar for success and error messages */}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={color ? "success" : "error"}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ForgotPassword;
